import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { APP_URLS } from '../../providers/constant';

@Injectable({
  providedIn: 'root'
})
export class SupportService {

  private supportApiUrl = `${APP_URLS.SUPPORT_API_URL}`;

  constructor(private http: HttpClient) { }

  public sendSupportMail(supportObject: any): Observable<any> {
    return this.http.post<any>(`${this.supportApiUrl}/sendcontactemail`, supportObject);
  }

}
